// extracted by mini-css-extract-plugin
module.exports = {"SrCMADiscussionModal":"SrCMADiscussionModal--SrCMADiscussionModal--2scvF","highlightYellowFadeIn":"SrCMADiscussionModal--highlightYellowFadeIn--1VVN8"};